// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=SF+Pro&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'SF Pro Display', Arial, sans-serif;
  background-color: #333;
  color: #fff;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.page-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
}

form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 400px;
  padding: 30px;
  background-color: #222;
  border: 1px solid #444;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
}

.form-group {
  margin-bottom: 20px;
  width: 100%;
}

label {
  font-family: 'SF Pro', Arial, sans-serif;
  font-weight: bold;
}

input[type='text'] {
  font-family: 'SF Pro', Arial, sans-serif;
  width: 100%;
  padding: 10px;
  border: 1px solid #444;
  border-radius: 5px;
  background-color: #444;
  color: #fff;
  box-sizing: border-box;
}

button[type='submit'] {
  font-family: 'SF Pro', Arial, sans-serif;
  font-weight: bold;
  width: 100%;
  padding: 10px;
  background-color: #2196f3;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.response-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px 30px 30px 30px;
  background-color: #222;
  border: 1px solid #444;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  max-height: 600px;
  overflow-y: auto;
}

.response-container h3 {
  margin-bottom: 10px;
}

.response-container pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.response-main-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: auto;
}

#downloadButton {
  font-weight: bold;
  font-family: 'SF Pro', Arial, sans-serif;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #2196f3;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.error-message {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 10px;
  background-color: #ff5252;
  color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  animation: fadeOut 2s ease-in forwards;
}

.error-message p {
  margin: 5px;
  font-size: 10pt;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,gDAAgD;EAChD,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=SF+Pro&display=swap');\n\nbody {\n  font-family: 'SF Pro Display', Arial, sans-serif;\n  background-color: #333;\n  color: #fff;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n}\n\n.page-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.form-container {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 20px;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 400px;\n  padding: 30px;\n  background-color: #222;\n  border: 1px solid #444;\n  border-radius: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\n}\n\n.form-group {\n  margin-bottom: 20px;\n  width: 100%;\n}\n\nlabel {\n  font-family: 'SF Pro', Arial, sans-serif;\n  font-weight: bold;\n}\n\ninput[type='text'] {\n  font-family: 'SF Pro', Arial, sans-serif;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #444;\n  border-radius: 5px;\n  background-color: #444;\n  color: #fff;\n  box-sizing: border-box;\n}\n\nbutton[type='submit'] {\n  font-family: 'SF Pro', Arial, sans-serif;\n  font-weight: bold;\n  width: 100%;\n  padding: 10px;\n  background-color: #2196f3;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.response-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  padding: 10px 30px 30px 30px;\n  background-color: #222;\n  border: 1px solid #444;\n  border-radius: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.response-container h3 {\n  margin-bottom: 10px;\n}\n\n.response-container pre {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n.response-main-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  overflow-y: auto;\n}\n\n#downloadButton {\n  font-weight: bold;\n  font-family: 'SF Pro', Arial, sans-serif;\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 10px;\n  background-color: #2196f3;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.error-message {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  padding: 10px;\n  background-color: #ff5252;\n  color: #fff;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);\n  animation: fadeOut 2s ease-in forwards;\n}\n\n.error-message p {\n  margin: 5px;\n  font-size: 10pt;\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
